import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainSection() {
  const pains = [{
    title: 'Llegás a migraciones y no entendés las preguntas del oficial',
    desc: 'El corazón a mil, sudando, asintiendo sin saber qué dijeron'
  }, {
    title: 'Subís al Tube y no sabés si el tren va para el lado correcto',
    desc: 'Mirás el mapa, mirás los carteles, no entendés nada, bajás en la parada equivocada'
  }, {
    title: 'Querés pedir comida en un pub y no sabés cómo',
    desc: 'Señalás como un turista, te traen algo diferente, pagás sin saber cuánto era'
  }, {
    title: 'Alguien se te acerca en la calle a ofrecerte algo gratis',
    desc: 'No sabés si es una estafa, no sabés cómo decir que no, terminás pagando por algo que no querías'
  }, {
    title: 'Te cobran de más en un restaurante y no podés reclamar',
    desc: 'Ves la cuenta mal, sabés que algo está mal, pero no tenés las palabras para decirlo'
  }, {
    title: 'Te perdés y no podés pedir ayuda',
    desc: 'El celular sin batería, sin señal, sin saber cómo preguntar dónde estás'
  }, {
    title: 'Necesitás ir a la farmacia porque te sentís mal',
    desc: 'No sabés cómo explicar los síntomas, no reconocés los remedios, perdés tiempo y plata'
  }, {
    title: 'Volvés de un viaje caro sintiéndote que te faltó aprovechar',
    desc: 'No porque no hayas ido a los lugares. Sino porque el idioma te limitó todo el tiempo.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-900/50 border-y border-slate-800" data-id="element-203">
      <div className="max-w-4xl mx-auto" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-205">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-206">
            ¿Cuántas noches más vas a pasar con ese{' '}
            <span className="text-red-400" data-id="element-207">miedo</span> antes de viajar?
          </h2>
          <div className="space-y-4 text-lg text-slate-300 max-w-2xl mx-auto" data-id="element-208">
            <p data-id="element-209">
              Viajás a Inglaterra. Lo planeaste durante meses. Lo ahorraste
              durante más tiempo todavía.
            </p>
            <p className="font-semibold text-white" data-id="element-210">
              Pero hay algo que no te deja dormir tranquilo.
            </p>
            <p data-id="element-211">No hablás inglés. O lo hablás muy poco.</p>
            <p data-id="element-212">
              Y Londres no es un destino fácil para el que no maneja el idioma.
            </p>
          </div>
        </motion.div>

        <div className="mt-16" data-id="element-213">
          <h3 className="text-xl font-bold text-center mb-8 text-slate-400 uppercase tracking-wider" data-id="element-214">
            Esto es lo que pasa cuando llegás sin preparación:
          </h3>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-215">
            {pains.map((pain, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-slate-800/40 p-6 rounded-xl border border-slate-700/50 flex gap-4" data-id="element-216">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-217" />
                <div data-id="element-218">
                  <h4 className="font-bold text-white mb-2" data-id="element-219">{pain.title}</h4>
                  <p className="text-slate-400 text-sm leading-relaxed" data-id="element-220">
                    {pain.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 text-center" data-id="element-221">
          <p className="text-xl text-slate-300 mb-4" data-id="element-222">
            No es falta de ganas. No es falta de inteligencia.{' '}
            <br className="hidden md:block" data-id="element-223" />{' '}
            <span className="font-bold text-white" data-id="element-224">
              Es falta de las herramientas correctas.
            </span>
          </p>
          <p className="text-2xl font-bold text-amber-400" data-id="element-225">
            ¿Y si este fuera el último viaje que hacés sin estar preparado?
          </p>
        </motion.div>
      </div>
    </section>;
}